import { Injectable, Inject } from '@angular/core';
import { Company } from '../models/missingdata.model';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  private Url: string;
  private missingBranches: BehaviorSubject<Company[]>;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.Url = baseUrl;
    this.missingBranches = new BehaviorSubject<Company[]>(JSON.parse(localStorage.getItem('missingBranches')));
  }

  getCompany() {
    return this.http.get<Company[]>(this.Url + 'api/company/')
  }

  updateCompany(branch: Company) {
    return this.http.patch(this.Url + 'api/company/', branch)
  }
  
}
